import React from 'react';
import ContentLoader from 'react-content-loader';

/**
 * Shimmer loader du drawer
 */
const CommandLoader = () => (
  <div>
    <ContentLoader
      height={360}
      width={208}
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="6" y="9" rx="0" ry="0" width="107" height="10" />
      <rect x="6" y="34" rx="0" ry="0" width="170" height="5" />

      <rect x="7" y="60" rx="0" ry="0" width="87" height="10" />
      <rect x="114" y="60" rx="0" ry="0" width="87" height="10" />

      <rect x="7" y="89" rx="0" ry="0" width="87" height="10" />
      <rect x="114" y="89" rx="0" ry="0" width="87" height="10" />

      <rect x="7" y="116" rx="0" ry="0" width="87" height="10" />
      <rect x="114" y="116" rx="0" ry="0" width="87" height="10" />

      <rect x="7" y="144" rx="0" ry="0" width="87" height="10" />
      <rect x="114" y="144" rx="0" ry="0" width="87" height="10" />

      <rect x="7" y="170" rx="0" ry="0" width="87" height="10" />
      <rect x="114" y="170" rx="0" ry="0" width="87" height="10" />
    </ContentLoader>
  </div>
);

export default CommandLoader;
